import React, {FC, useState} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  OnboardingEventsEnum,
  trackEvent,
  TrackingTypesEnum,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {CenteredPopover} from '../../../../libs/shared/ui/src/components/popovers/centeredPopover';
import {OnboardingVideoSlide} from './onboardingVideoSlide';

/*
 * Props.
 */

interface OnboardingVideoPopoverProps {
  onSubmit: () => void;
}

/*
 * Component.
 */

export const OnboardingVideoPopover: FC<OnboardingVideoPopoverProps> = (props) => {
  const {onSubmit} = props;

  const [hasPlayedVideo, setHasPlayedVideo] = useState(false);

  // Video slide state.
  const [videoDuration, setVideoDuration] = useState<number>(0);

  return (
    <CenteredPopover>
      <OnboardingVideoSlide
        onNext={() => {
          trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.VIDEO_NEXT);
          trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED_VIDEO);
          onSubmit();
        }}
        setHasPlayedVideo={setHasPlayedVideo}
        hasPlayedVideo={hasPlayedVideo}
        videoDuration={videoDuration}
        setVideoDuration={setVideoDuration}
        nextButtonContent={<Trans id="onboarding-video-popover-start-trial">Start trial</Trans>}
      />
    </CenteredPopover>
  );
};
